export default __webpack_public_path__ + "static/shipmentManagementVp2-1-c16b203baf5cd3597e5eab22302b9a0d.png";